(function () {

  const rt = '[data-skip-upsell-product]';
  const Dt = '[data-quick-add-holder]';
  const Kt = 'data-quick-add-holder';
  const Bt = '[data-upsell-widget]';
  const Nt = '[data-collapsible-body]';
  const V = 'is-hidden';
  const Yt = 'open';
  const Zt = 'data-upsell-auto-open';

  function extendCartItems() {
    const CartItemsClass = customElements.get('cart-items');
    if (!CartItemsClass) {
      setTimeout(extendCartItems, 100);
      return;
    }

    const proto = CartItemsClass.prototype;

    proto.refreshProductListUpsell = function () {
      if (this._upsellRefreshTimer) clearTimeout(this._upsellRefreshTimer);
      this._upsellRefreshTimer = setTimeout(() => this._doUpsellRefresh(), 1000);
    };

    proto._doUpsellRefresh = function () {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      const now = Date.now();
      if (this._lastUpsellFetchTime && (now - this._lastUpsellFetchTime) < 500) return;
      this._lastUpsellFetchTime = now;

      const themeId = window.Shopify?.theme?.id;
      const previewParam = themeId ? `&preview_theme_id=${themeId}` : '';

      fetch(`/?section_id=api-upsell${previewParam}`).then(t => t.text()).then(html => {
        const allWidgets = document.querySelectorAll('[data-upsell-widget]');
        for (let i = 1; i < allWidgets.length; i++) {
          const parent = allWidgets[i].closest('.cart-block');
          if (parent && parent.children.length === 1) parent.remove();
          else allWidgets[i].remove();
        }

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const newUpsellWidget = tempDiv.querySelector('[data-upsell-widget]');
        const currentUpsellWidget = document.querySelector('[data-upsell-widget]');

        if (!newUpsellWidget) {
          if (currentUpsellWidget) currentUpsellWidget.classList.add('is-hidden');
          return;
        }

        const newProducts = newUpsellWidget.querySelector('[data-product-list-upsell]');
        if (!newProducts || newProducts.children.length === 0) return;

        if (currentUpsellWidget) {
          const currentProducts = currentUpsellWidget.querySelector('[data-product-list-upsell]')
            || currentUpsellWidget.querySelector('[data-upsell-products]');

          if (currentProducts) {
            currentProducts.innerHTML = newProducts.innerHTML;
            currentUpsellWidget.classList.remove('is-hidden');
            this.reinitUpsellSlider(currentUpsellWidget);
            return;
          }

          const currentInner = currentUpsellWidget.querySelector('.cart__widget__products');
          if (currentInner) {
            currentInner.innerHTML = newProducts.innerHTML;
            currentUpsellWidget.classList.remove('is-hidden');
            this.reinitUpsellSlider(currentUpsellWidget);
            return;
          }
        } else {
          const cartBody = cartDrawer.querySelector('[data-cart-drawer-body]');
          const checkoutButtons = cartDrawer.querySelector('[data-checkout-buttons]');

          if (cartBody) {
            const wrapper = document.createElement('div');
            wrapper.className = 'cart-block';
            wrapper.appendChild(newUpsellWidget);

            if (checkoutButtons) checkoutButtons.parentNode.insertBefore(wrapper, checkoutButtons);
            else cartBody.appendChild(wrapper);

            const summary = newUpsellWidget.querySelector('summary.cart__widget__title');
            if (summary) {
              const iconsHTML = summary.innerHTML.match(/<svg[\s\S]*?<\/svg>/g)?.join('') || '';
              summary.innerHTML = 'Vervollständige deinen Look' + iconsHTML;
            }

            newUpsellWidget.setAttribute('open', 'true');
            const body = newUpsellWidget.querySelector('[data-collapsible-body]');
            if (body) { body.style.height = 'auto'; body.style.overflow = 'visible'; }
            const content = newUpsellWidget.querySelector('.cart__widget__content');
            if (content) content.style.height = 'auto';

            if (summary) {
              summary.addEventListener('click', (e) => {
                e.preventDefault();
                const isOpen = newUpsellWidget.hasAttribute('open');
                if (isOpen) {
                  newUpsellWidget.removeAttribute('open');
                  if (body) body.style.height = '';
                  if (content) content.style.height = '';
                } else {
                  newUpsellWidget.setAttribute('open', 'true');
                  if (body) { body.style.height = 'auto'; body.style.overflow = 'visible'; }
                  if (content) content.style.height = 'auto';
                }
              });
            }

            this.reinitUpsellSlider(newUpsellWidget);
          }
        }
      }).catch(() => {});
    };

    proto.saveLastUpsellType = function (productType) {
      if (!productType) return;
      fetch('/cart.js').then(r => r.json()).then(cart => {
        const newCounter = parseInt(cart.attributes._upsell_counter || '0', 10) + 1;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { '_upsell_counter': String(newCounter) } })
        }).catch(() => {});
      }).catch(() => {});
    };

    proto.reinitUpsellSlider = function (widget) {
      const wrapper = widget.querySelector('.upsell-slider-wrapper');
      if (!wrapper) return;

      const slider = wrapper.querySelector('.cart__widget__products');
      const leftArrow = wrapper.querySelector('.upsell-arrow--left');
      const rightArrow = wrapper.querySelector('.upsell-arrow--right');
      if (!slider || !leftArrow || !rightArrow) return;

      const items = slider.querySelectorAll('quick-add-product');
      if (items.length < 3) {
        leftArrow.style.display = 'none';
        rightArrow.style.display = 'none';
        return;
      }

      leftArrow.style.display = '';
      rightArrow.style.display = '';

      const newLeft = leftArrow.cloneNode(true);
      const newRight = rightArrow.cloneNode(true);
      leftArrow.parentNode.replaceChild(newLeft, leftArrow);
      rightArrow.parentNode.replaceChild(newRight, rightArrow);

      newLeft.style.opacity = '';
      newLeft.style.pointerEvents = '';
      newRight.style.opacity = '';
      newRight.style.pointerEvents = '';

      const updateArrows = () => {
        const sl = slider.scrollLeft;
        const max = slider.scrollWidth - slider.clientWidth;
        newLeft.style.opacity = sl <= 5 ? '0' : '1';
        newLeft.style.pointerEvents = sl <= 5 ? 'none' : 'auto';
        newRight.style.opacity = sl >= max - 5 ? '0' : '1';
        newRight.style.pointerEvents = sl >= max - 5 ? 'none' : 'auto';
      };

      newRight.addEventListener('click', () => slider.scrollBy({ left: 150, behavior: 'smooth' }));
      newLeft.addEventListener('click', () => slider.scrollBy({ left: -150, behavior: 'smooth' }));
      slider.addEventListener('scroll', updateArrows);
      updateArrows();

      slider.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: true });
      slider.addEventListener('touchmove', (e) => e.stopPropagation(), { passive: true });

      let isDown = false, startX, scrollLeft;
      slider.addEventListener('mousedown', (e) => { isDown = true; slider.style.cursor = 'grabbing'; startX = e.pageX - slider.offsetLeft; scrollLeft = slider.scrollLeft; });
      slider.addEventListener('mouseleave', () => { isDown = false; slider.style.cursor = ''; });
      slider.addEventListener('mouseup', () => { isDown = false; slider.style.cursor = ''; });
      slider.addEventListener('mousemove', (e) => { if (!isDown) return; e.preventDefault(); slider.scrollLeft = scrollLeft - (e.pageX - slider.offsetLeft - startX) * 1.5; });
    };

    proto.skipUpsellProductEvent = function () {
      if (null === this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(rt);
      t.length && t.forEach((t => {
        t.addEventListener("click", (e => {
          e.preventDefault();
          const s = t.closest(Dt).getAttribute(Kt);
          this.skipUpsellProductsArray.includes(s) || this.skipUpsellProductsArray.push(s);
          window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray);
          this.removeUpsellProduct(s);
          this.toggleCartUpsellWidgetVisibility();
        }));
      }));
    };

    proto.checkSkippedUpsellProductsFromStorage = function () {
      const t = window.sessionStorage.getItem("skip_upsell_products");
      if (!t) return;
      t.split(",").forEach((t => {
        this.skipUpsellProductsArray.includes(t) || this.skipUpsellProductsArray.push(t);
        this.removeUpsellProduct(t);
      }));
    };

    proto.removeUpsellProduct = function (t) {
      if (!this.upsellProductsHolder) return;
      const e = this.upsellProductsHolder.querySelector(`[${Kt}="${t}"]`);
      e && e.parentNode.remove();
    };

    proto.toggleCartUpsellWidgetVisibility = function () {
      if (!this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(Dt),
        e = this.upsellProductsHolder.closest(Bt);
      if (e && (e.classList.toggle(V, !t.length), t.length && !e.hasAttribute(Yt) && e.hasAttribute(Zt))) {
        e.setAttribute(Yt, !0);
        const t = e.querySelector(Nt);
        t && (t.style.height = "auto");
      }
    };

    document.addEventListener('theme:cart:change', () => {
      const v1Widget = document.querySelector('[data-upsell-widget]');
      if (v1Widget && window.getComputedStyle(v1Widget).display === 'none') return;
      const cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl && cartItemsEl.refreshProductListUpsell) {
        cartItemsEl.refreshProductListUpsell();
      }
    });

    document.addEventListener("DOMContentLoaded", function () {
      const sliders = document.querySelectorAll(".upsell-slider-wrapper");
      sliders.forEach(wrapper => {
        const slider = wrapper.querySelector(".cart__widget__products");
        const leftArrow = wrapper.querySelector(".upsell-arrow--left");
        const rightArrow = wrapper.querySelector(".upsell-arrow--right");
        if (!slider) return;

        const items = slider.querySelectorAll("quick-add-product");
        if (items.length < 3) {
          if (leftArrow) leftArrow.style.display = "none";
          if (rightArrow) rightArrow.style.display = "none";
          return;
        }

        function updateArrows() {
          const sl = slider.scrollLeft;
          const max = slider.scrollWidth - slider.clientWidth;
          leftArrow.style.opacity = sl <= 5 ? "0" : "1";
          leftArrow.style.pointerEvents = sl <= 5 ? "none" : "auto";
          rightArrow.style.opacity = sl >= max - 5 ? "0" : "1";
          rightArrow.style.pointerEvents = sl >= max - 5 ? "none" : "auto";
        }

        rightArrow.addEventListener("click", () => slider.scrollBy({ left: 150, behavior: "smooth" }));
        leftArrow.addEventListener("click", () => slider.scrollBy({ left: -150, behavior: "smooth" }));
        slider.addEventListener("scroll", updateArrows);
        updateArrows();
      });
    });

    document.addEventListener("click", function (e) {
      const quickAdd = e.target.closest('quick-add-product');
      if (!quickAdd) return;
      const upsellContainer = quickAdd.closest('[data-product-list-upsell]');
      if (!upsellContainer) return;
      const isAddButton = e.target.closest('[data-add-to-cart]') || e.target.closest('[data-quick-add-modal-handle]') || e.target.closest('[data-quick-add-btn]');
      if (!isAddButton) return;
      const productType = quickAdd.getAttribute('data-product-type');
      const cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl && cartItemsEl.saveLastUpsellType) cartItemsEl.saveLastUpsellType(productType);
    }, true);
  }

  extendCartItems();

})();